import React, { Component } from "react"
import { ModalContainer, ModalDialog } from "react-modal-dialog"
import ItemNotaForm from "./ItemNotaForm"
import * as ApiHelper from "../../ApiHelper"
import { HttpError } from "../../components"
export default class ItemNotaModal extends Component {
  constructor() {
    super()
    this.callBackItem = this.callBackItem.bind(this)
    this.state = { isShowingModal: false }
  }
  getUnidades() {
    ApiHelper.getItemNotaEdit(this.props.itemID, (item, error) => {
      if (item) {
        this.props.callBack(item)
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  callBackItem() {
    this.getUnidades()
  }
  render() {
    if (this.state.httpError) {
      return (
        <div onClick={this.props.onClose}>
          {this.props.show && (
            <ModalContainer onClose={this.props.onClose}>
              <ModalDialog
                style={{ width: "70%" }}
                onClose={this.props.onClose}
              >
                <HttpError
                  message={this.state.httpError.message}
                  status={this.state.httpError.status}
                />
              </ModalDialog>
            </ModalContainer>
          )}
        </div>
      )
    }
    return (
      <div onClick={this.props.onClose}>
        {this.props.show && (
          <ModalContainer onClose={this.props.onClose}>
            <ModalDialog style={{ width: "70%" }} onClose={this.props.onClose}>
              <ItemNotaForm
                itemID={this.props.itemID}
                callBackItem={this.callBackItem}
              />
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/modais/ItemNotaModal.js